enum TaskSortField {
    LATEST_ACTIVITY_AT = 'latest_activity_at',
    PUBLISH_AT = 'publish_at',
    DEADLINE_AT = 'deadline_at',
    PRIORITY_ELEVATION = 'priority_elevation',
    STATE = 'state',
}

export default TaskSortField;
